// extracted by mini-css-extract-plugin
export default {"headerWrapper":"Header_headerWrapper__PQWJM","headerNavigation":"Header_headerNavigation__Rpywu","logoStyle":"Header_logoStyle__mtQ3W","logoTitle":"Header_logoTitle__qWAaK"};